import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import Home from './views/home/Home';

class Router extends Component{
    render(){
        return(
            <BrowserRouter>
                <Switch>
                    <Route path="/documentacion" component={Home}></Route>
                </Switch>
            </BrowserRouter>
        );
    }
}
export default Router;